<template>
  <task-container />
</template>

<script>
import { TaskContainer } from '@/modules/tasks';

export default {
  components: {
    TaskContainer
  }
}
</script>
